$(document).ready(function()
{

    $(".slick-standard").slick({
        dots: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
    });

    $(".slick-speakers").slick({
        dots: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 3500,
        pauseOnHover:true,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        centerMode: true,
        centerPadding: '10px',
        variableWidth: false,
        focusOnSelect: true,
        cssEase: 'linear',
        touchMove: true,
        responsive: 
        [
            {
                breakpoint: 720,
                settings: 
                {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }

        ]
    });

    $(".slick-featured").slick({
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3500,
        fade: true,
        cssEase: 'linear'
        
    });


    $(".slick-auto").slick({
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3500,
        //fade: true,
        //cssEase: 'linear',
        pauseOnHover:true,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false,
        responsive: 
        [
            {
                breakpoint: 640,
                settings: 
                {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }

        ]

    });

    $(".slick-centered").slick({

        arrows: true,
        centerMode: true,
        centerPadding: '10px',
        slidesToShow: 3,
        infinite: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                }
            }

        ]

    });

    $(".slick-centered-people").slick({

        centerMode: true,
        //centerPadding: '40px',
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        //slidesToScroll: 1,
        infinite: true,
        autoplay: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                }
            }

        ]


    });


    $('.slick-thumbs-top').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: true,
        centerMode: true,
        asNavFor: '.slick-thumbs-bottom'
    });
    $('.slick-thumbs-bottom').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.slick-thumbs-top',
        dots: false,
        arrows: true,
        centerMode: true,
        focusOnSelect: true

    });

    $(".slick-cards").slick({
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 3.1,
        slidesToScroll: 3,
        centerMode: false,
        responsive: 
        [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2.1,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: false,
                    arrows: true,
                    centerMode: false,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1.1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    centerMode: false,

                }
            }
        ]
    });

    $(".slick-cards2").slick({
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 2.1,
        slidesToScroll: 2,
        centerMode: false,
        responsive: 
        [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1.1,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    arrows: true,
                    centerMode: false,
                }
            }
        ]
    });

    $(".slick-loop").slick({
        dots: false,
        arrows: false,
        autoplay: true,
        speed: 6000,
        autoplaySpeed: 0,
        pauseOnHover:true,
        pauseOnFocus: true,
        cssEase: 'linear',
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: 
        [
            {
                breakpoint: 1080,
                settings: 
                {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 720,
                settings: 
                {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            }
        ]      
    });

    //resize each of our slick sliders to uniform height
    $('.slick-cards, .slick-cards2, .slick-cards3, .slick-cards4, .slick-loop').each(function()
    {
        var cards = $(this).find( ".col" );
        var maxHeight = 0;

        if (cards)
        {
            //console.log ("children: " + cards.length);
            window.setTimeout(function()
            { 
                for (var i = 0; i < cards.length; i++) 
                {
                    if (maxHeight < $(cards[i]).outerHeight()) 
                    {
                        maxHeight = $(cards[i]).outerHeight();
                    }
                }
                //console.log(maxHeight);
                cards.height(maxHeight);
            }, 500 );
        }
    });

});
 
// slick changes on resize
$(window).on('load resize orientationchange', function() 
{
    $('.slick-on-small').each(function(){
        var $carousel = $(this);

        if ($(window).width() > 640) 
        {
            if ($carousel.hasClass('slick-initialized')) {
                $carousel.slick('unslick');
            }
        }
        else
        {
            if (!$carousel.hasClass('slick-initialized')) 
            {
                $carousel.slick({
                  dots: true,
                  arrows: false,
                  infinite: false,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode: false,
                  //autoplay: true,
                  pauseOnHover:true,
                  pauseOnFocus: false,
                  autoplaySpeed: 5000,
                });
            }
        }
    });

});
